import React from "react";
const PremiumSVG  = (props) => {
  return (
    <svg
    fill="#000000"
    height="200px"
    width="200px"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 215.777 215.777"
    xmlSpace="preserve"
    stroke="#000000"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <path d="M198.333,164.99l-17.387-17.388c0.996-0.787,1.905-1.701,2.69-2.779c3.987-5.478,3.017-12.68,2.16-19.033 c-0.541-4.014-1.101-8.163-0.249-10.785c0.784-2.415,3.587-5.327,6.299-8.144c4.536-4.713,9.677-10.054,9.677-17.098 s-5.141-12.386-9.677-17.098c-2.711-2.816-5.515-5.729-6.298-8.143c-0.853-2.623-0.293-6.773,0.248-10.787 c0.856-6.354,1.827-13.555-2.159-19.032c-4.024-5.529-11.215-6.828-17.559-7.973c-3.951-0.714-8.037-1.451-10.213-3.035 c-2.125-1.546-4.062-5.169-5.934-8.673c-3.062-5.726-6.53-12.215-13.119-14.354C135.445,0.226,133.982,0,132.464,0 c-4.885,0-9.621,2.278-14.201,4.48c-3.706,1.783-7.538,3.626-10.397,3.626c-2.86,0-6.691-1.843-10.397-3.626 C92.888,2.278,88.153,0,83.267,0c-1.518,0-2.98,0.226-4.348,0.669C72.331,2.809,68.861,9.298,65.8,15.024 c-1.872,3.503-3.809,7.125-5.933,8.671c-2.176,1.584-6.262,2.321-10.213,3.035c-6.344,1.145-13.534,2.443-17.56,7.974 c-3.986,5.478-3.016,12.679-2.159,19.031c0.541,4.014,1.101,8.164,0.248,10.787c-0.783,2.414-3.587,5.327-6.298,8.144 c-4.536,4.713-9.677,10.054-9.677,17.098c0,7.043,5.141,12.384,9.676,17.096c2.712,2.817,5.516,5.73,6.299,8.145 c0.853,2.623,0.293,6.773-0.248,10.786c-0.856,6.354-1.827,13.555,2.159,19.032c0.792,1.089,1.71,2.008,2.717,2.8L17.444,164.99 c-4.675,4.676-3.81,8.895-3.22,10.491c0.589,1.597,2.67,5.367,9.261,5.887l17.144,1.354c3.045,0.241,5.926,3.122,6.166,6.166 l1.354,17.145c0.567,7.192,5,9.745,8.623,9.745h0.001c1.847,0,4.691-0.643,7.754-3.705l40.059-40.058 c1.178-0.363,2.29-0.594,3.28-0.594c1.009,0,2.143,0.238,3.345,0.613l40.039,40.039c3.062,3.063,5.906,3.705,7.754,3.705 c3.623,0,8.056-2.552,8.624-9.745l1.354-17.144c0.241-3.045,3.122-5.926,6.165-6.167l17.146-1.354 c6.591-0.52,8.672-4.29,9.261-5.887C202.143,173.885,203.008,169.666,198.333,164.99z M124.585,99.641l10.221,31.378l-26.759-19.481 l-26.759,19.422L91.51,99.651L64.751,80.357h33.076l10.221-31.457l10.221,31.457h33.076L124.585,99.641z" />
    </g>
  </svg>
  );
};

export default PremiumSVG ;
